import { useQuery } from '@apollo/react-hooks';

import { isErrorMarkedAsHandled, markErrorAsHandled } from '@confluence/graphql-error-processor';

import { TrialDetailsQuery } from '../../graphql/TrialDetailsQuery.graphql';
import { getTrialDaysLeftFromQuery } from '../../graphql/getTrialDaysLeftFromQuery';

export const useDaysLeftTrial = () => {
	const { data, error, loading } = useQuery(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
		TrialDetailsQuery,
		{
			fetchPolicy: 'cache-and-network',
		},
	);

	if (error && !isErrorMarkedAsHandled(error)) {
		markErrorAsHandled(error);
	}

	return {
		error,
		loading,
		daysLeft: getTrialDaysLeftFromQuery(data),
	};
};
